
import Dom from '../base/mdom.js';
function CustomEvent(){
        this.queue = {};
        this.state = {};
        this.objs  = {};
}


CustomEvent.prototype.on = function(eventName, cbk ) {
        if (this.state[eventName]) {
            cbk(this.objs[eventName]);
        } else {
            if (!this.queue[eventName]) {
                this.queue[eventName] = [];
            }
            this.queue[eventName].push(cbk);
        }
    };

CustomEvent.prototype.emit = function(eventName, obj, isShortState) {
    var obj = obj || null;
    this.state[eventName] = isShortState ? false : true;
    this.objs[eventName] = obj;
    if (!this.queue[eventName]) {
        this.queue[eventName] = []
    }

    this.queue[eventName].forEach(function(cbk) {
        cbk(obj);
    });
}

CustomEvent.prototype.trigger = function(eventName, obj) {
    var obj = obj || null;
    this.objs[eventName] = obj;
    if (!this.queue[eventName]) {
        this.queue[eventName] = []
    }

    this.queue[eventName].forEach(function(cbk) {
        cbk(obj);
    });
}

CustomEvent.prototype.emitOnce = function(eventName, obj) {
        obj = obj || null;

        this.emit(eventName, obj);

        // 只负责把已注册的事件完成，然后注销自己
        this.queue[eventName] = [];
        this.state[eventName] = false;
        this.objs[eventName] = {};
}

var __custom;
function singletonHandler() {
    if (!__custom) {
        __custom = new CustomEvent();
    }
    return __custom;
}
var UniBus = singletonHandler();
Dom.window.UniBus  = Dom.window.UniBus || UniBus;
export default UniBus;